<div class="grid">
  @for(item of items; track $index) { @if(item.isInfo) {
  <div class="card">
    <div class="card__header">
      <h2>
        <mat-icon fontSet="material-symbols-outlined">{{
          item.info!.matIconName
        }}</mat-icon>
        {{ item.info!.title }}
      </h2>
    </div>
    <div
      class="card__body"
      [innerHTML]="item.info!.htmlContent | formatNumbersHtml"
    ></div>
  </div>
  }@else {
  <div class="img-container">
    <img
      [src]="'../../../../../assets/img/' + item.imageFileName + '.png'"
      alt=""
    />
  </div>

  } }
</div>
